<template>
  <span>
    <v-list-tile @click="newUserDialog = !newUserDialog">
      <v-list-tile-action>
        <v-icon>group_add</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>Add new user</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <v-list-tile @click="newPermissionDialog = !newPermissionDialog">
      <v-list-tile-action>
        <v-icon>post_add</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>Add new permission</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <v-dialog v-model="newUserDialog" :width="dialogWidth" transition="dialog-transition">
      <v-card color="primary lighten-1">
        <v-card-title primary-title>
          <h2>Add a new user</h2>
        </v-card-title>
        <UserSearch class="ma-4" @employee-selected="userSelected" />
        <v-card-actions>
          <v-btn
            class="ma-4"
            @click="
              newUserDialog = false; 
              newUser = {
                employeeID: false,
                displayName: false,
                permissions: []
              };"
          >Cancel</v-btn>
          <v-spacer />
          <v-btn class="ma-4 success" @click="addNewUser">Add user</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="newPermissionDialog" :width="dialogWidth" transition="dialog-transition">
      <v-card color="primary lighten-1">
        <v-card-title primary-title>
          <h2>Add a new permission</h2>
        </v-card-title>

        <v-text-field
          box
          class="ma-4"
          label="Name of Permission"
          v-model="newPermissionName"
          browser-autocomplete="off"
          color="secondary"
          hide-details
        ></v-text-field>

        <v-card-actions>
          <v-btn
            class="ma-4"
            @click="
              newPermissionDialog = false;
            newPermissionName='';"
          >Cancel</v-btn>
          <v-spacer />
          <v-btn class="ma-4 success" @click="addNewPermission">Add Permission</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import { mapGetters } from "vuex";
import UserSearch from "@/components/app/UserSearch";

export default {
  name: "PermissionNavigation",

  data() {
    return {
      newPermissionDialog: false,
      newUserDialog: false,
      possiblePermissions: [],
      newUser: {
        employeeID: false,
        displayName: false,
        permissions: []
      },
      newPermissionName: ""
    };
  },

  computed: {
    ...mapGetters({
      permissions: "settings/getPermissions"
    }),
    dialogWidth() {
      if (this.$vuetify.breakpoint.xs) {
        return "100%";
      } else if (this.$vuetify.breakpoint.sm) {
        return "50%";
      } else if (this.$vuetify.breakpoint.md) {
        return "40%";
      }
      return "30%";
    }
  },

  components: {
    UserSearch
  },
  watch: {
    newUserDialog() {
      this.newUser = {
        employeeID: false,
        displayName: false,
        permissions: []
      };
    },
    newPermissionDialog() {
      this.newPermissionName = "";
    },
    permissions: {
      handler(val) {
        if (val.length > 0) {
          this.possiblePermissions = val[0].permissions.map(permission => {
            return {
              permissionID: permission.permissionID,
              name: permission.name,
              permission: true
            };
          });
        }
      },
      deep: true
    }
  },
  methods: {
    userSelected(e) {
      let displayName = null;
      let employeeID = null;
      try {
        displayName = e.split("(")[0].trim();
        employeeID = e.match(/\d+/)[0];
      } catch {
        employeeID = 0;
      }

      let newPermissions = this.possiblePermissions;
      newPermissions.forEach(permission => {
        permission.permission = false;
      });

      this.newUser = {
        displayName,
        employeeID,
        permissions: newPermissions
      };
    },

    async addNewUser() {
      if (this.newUser.displayName) {
        await this.$store.dispatch("settings/addUserToPermissions", {
          body: this.newUser
        });
        await this.$store.dispatch("settings/getPermissions");
        this.newUserDialog = false;
      } else
        this.$store.dispatch("app/setSnackbar", {
          color: "red",
          text: "Please select a user!"
        });
    },

    async addNewPermission() {
      const newPermission = {
        permissionID: this.permissions[0].permissions.length + 1,
        name: this.newPermissionName,
        permission: false
      };

      if (this.newPermissionName) {
        await this.$store.dispatch("settings/addPermission", {
          body: newPermission
        });
        await this.$store.dispatch("settings/getPermissions");
        this.newPermissionDialog = false;
      } else
        this.$store.dispatch("app/setSnackbar", {
          color: "red",
          text: "Please enter a permission name!"
        });
    }
  }
};
</script>

<style>
</style>